import { supabase } from '../supabaseClient';
import { Stop, Photo } from '../types';

export async function fetchStop(stopId: string): Promise<{ data: Stop | null; error: string | null }> {
  const { data, error } = await supabase.from('stops').select('*').eq('stop_id', stopId).maybeSingle();
  if (error) return { data: null, error: error.message };
  return { data: data as Stop | null, error: null };
}

export async function updateStop(
  stopId: string,
  patch: Partial<Pick<Stop, 'title' | 'notes' | 'context' | 'address' | 'is_hidden_from_share'>>,
): Promise<{ data: Stop | null; error: string | null }> {
  const { data, error } = await supabase
    .from('stops')
    .update({ ...patch, updated_at: new Date().toISOString() })
    .eq('stop_id', stopId)
    .select()
    .single();
  if (error) return { data: null, error: error.message };
  return { data: data as Stop, error: null };
}

export async function fetchPhotosForStop(stopId: string): Promise<{ data: Photo[]; error: string | null }> {
  const { data, error } = await supabase
    .from('photos')
    .select('*')
    .eq('stop_id', stopId)
    .order('taken_at', { ascending: true, nullsFirst: false });
  if (error) return { data: [], error: error.message };
  return { data: (data ?? []) as Photo[], error: null };
}

export async function setPhotoHidden(
  photoId: string,
  hidden: boolean,
): Promise<{ error: string | null }> {
  const { error } = await supabase
    .from('photos')
    .update({ is_hidden_from_share: hidden })
    .eq('photo_id', photoId);
  return { error: error?.message ?? null };
}
